import { axiosInstance, requestConfig } from 'network/apis';

import { URL_GAME } from 'utils/constants';

export const callTournamentList = async (data) => {
    return await axiosInstance(requestConfig('get', URL_GAME, `/tournament`, data));
};

export const callDeleteTournament = async (tournamentId) => {
    return await axiosInstance(requestConfig('delete', URL_GAME, `/tournament/${tournamentId}`));
};

export const callEarlyEndTournament = async (tournamentId) => {
    return await axiosInstance(requestConfig('put', URL_GAME, `/tournament/${tournamentId}/early-end`));
};
